import React from "react";
import { Modal, Form, InputNumber, Space } from "antd";

const CameraLocationModal = ({
  isOpen,
  onClose,
  cameras = [],
  onSave,
  existingLocations = {},
}) => {
  const [form] = Form.useForm();

  const handleSubmit = () => {
    form.validateFields().then((values) => {
      const locations = {};
      Object.keys(values).forEach((key) => {
        const [cameraId, coord] = key.split("-");
        if (!locations[cameraId]) {
          locations[cameraId] = {};
        }
        locations[cameraId][coord] = values[key];
      });

      // Convert to final format: { "5": "(472,277)" }
      const formattedLocations = {};
      Object.keys(locations).forEach((cameraId) => {
        const coords = locations[cameraId];
        if (coords.x !== undefined && coords.y !== undefined) {
          formattedLocations[cameraId] = `(${coords.x},${coords.y})`;
        }
      });

      onSave(formattedLocations);
      onClose();
    });
  };

  // Parse existing locations back to numbers for the form
  const getInitialValues = () => {
    const values = {};
    if (existingLocations && typeof existingLocations === "object") {
      Object.entries(existingLocations).forEach(([cameraId, coordString]) => {
        const matches = coordString.match(/\((\d+),(\d+)\)/);
        if (matches) {
          values[`${cameraId}-x`] = parseInt(matches[1]);
          values[`${cameraId}-y`] = parseInt(matches[2]);
        }
      });
    }
    return values;
  };

  // Reset form when modal opens with new values
  React.useEffect(() => {
    if (isOpen) {
      form.setFieldsValue(getInitialValues());
    }
  }, [isOpen, existingLocations]);

  return (
    <Modal
      title="Camera Locations"
      open={isOpen}
      onCancel={onClose}
      onOk={handleSubmit}
      width={500}
    >
      <Form form={form} layout="vertical" initialValues={getInitialValues()}>
        {cameras.map((camera) => (
          <Form.Item
            key={camera.id}
            label={camera.title}
            style={{ marginBottom: 24 }}
          >
            <Space>
              <Form.Item name={`${camera.id}-x`} noStyle>
                <InputNumber
                  placeholder="X"
                  min={0}
                  style={{ width: 100 }}
                  addonBefore="X:"
                />
              </Form.Item>
              <Form.Item name={`${camera.id}-y`} noStyle>
                <InputNumber
                  placeholder="Y"
                  min={0}
                  style={{ width: 100 }}
                  addonBefore="Y:"
                />
              </Form.Item>
            </Space>
          </Form.Item>
        ))}
      </Form>
    </Modal>
  );
};

export default CameraLocationModal;
